import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { head } from 'lodash';

export function Loading({ isLoading, parentContainer, isContainer = true }) {
  const el = head(document.getElementsByClassName('card-body'));
  return (
    isLoading && (
      <div
        className="d-flex justify-content-center align-items-center position-absolute"
        style={{
          zIndex: 2000,
          minWidth: `calc(${(parentContainer ?? el)?.offsetWidth}px ${
            isContainer ? '- 1.25rem' : ''
          })`,
          minHeight: `calc(${(parentContainer ?? el)?.offsetHeight}px ${
            isContainer ? '- 1.25rem' : ''
          })`,
          background: 'white',
          opacity: 0.95,
        }}
      >
        <CircularProgress color="secondary"></CircularProgress>
      </div>
    )
  );
}
